import React from "react"
import { FiMoon, FiSun } from "react-icons/fi"
import { FaAlignRight } from "react-icons/fa"
import PageLinks from "../../constants/links"

import {
  Nav,
  Content,
  Logo,
  ThemeTogglerWrapper,
  Button,
  HomeLink,
  ToggleButton,
} from "./Nav.styled"
const Navbar = ({ toggleSidebar, toggleTheme, isDarkTheme }) => {
  return (
    <Nav id="#navbar">
      <Content>
        <HomeLink to="/">
          <Logo>
            Wonde<span>.Shi</span>
          </Logo>
        </HomeLink>
        <PageLinks styleClass="nav-links"></PageLinks>
      </Content>
      <ToggleButton type="button" onClick={toggleSidebar}>
        <FaAlignRight></FaAlignRight>
      </ToggleButton>
      <ThemeTogglerWrapper onClick={toggleTheme}>
        <FiMoon /> <FiSun />
        <Button
          isDarkTheme={isDarkTheme}
          className={isDarkTheme ? "on" : "off"}
        ></Button>
      </ThemeTogglerWrapper>
    </Nav>
  )
}

export default Navbar
